import { render, staticRenderFns } from "./page-header-title.vue?vue&type=template&id=8b945e0a&scoped=true"
import script from "./page-header-title.vue?vue&type=script&lang=js"
export * from "./page-header-title.vue?vue&type=script&lang=js"
import style0 from "./page-header-title.vue?vue&type=style&index=0&id=8b945e0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b945e0a",
  null
  
)

export default component.exports